import React, {useContext, useEffect} from 'react';
import LayoutContext from './LayoutContext/LayoutContext';
import {ThemeContext} from '../../../themes/ThemeProvider';
import { IconButton } from '@mui/material';
import { Close, Menu } from '@material-ui/icons';

const SidebarToggleHandler = ({children, ...restProps}) => {
  const {isOpen, setOpen} = useContext(LayoutContext);
  const {setShowWidgetSection, setSideNavSection} = useContext(ThemeContext);
  useEffect(() => {
    if (isOpen) {
      setShowWidgetSection(false);
      setSideNavSection(true);
    } else {
      setSideNavSection(false);
    }
  }, [isOpen]);

  return (
    <IconButton color="inherit" edge="start" sx={{ mr: 2, display: { lg: 'none' } }} onClick={() => setOpen(!isOpen)} {...restProps}>
      {isOpen ? <Close /> : <Menu />}
    </IconButton>
  );
};

export default SidebarToggleHandler;
